import { combineReducers } from 'redux';
import myReviews from './MyReviewsReducers/index';
import myRewards from './myRewardsReducer';
import wallet from './WalletReducers';
import giftcard from './GiftCardReducers';
import wishlistPageData from './MyWishlist/wishlistPageReducer';
import myProfileInfo from './MyProfileInfoReducers/index';
import myAddresses from './MyAddresses/myAddressesReducer';
import savedCards from './SavedCardReducers/savedCardReducer';
import savedVpas from './SavedVpaReducers/savedVpaReducer';
import bnpl from './BuyNowPayLater';
import panCard from './PanCard/panCardReducer';

const myAccountReducer = combineReducers({
	myReviews,
	myProfileInfo,
	myRewards,
	wallet,
	giftcard,
	myAddresses,
	wishlistPageData,
	savedCards,
	savedVpas,
	bnpl,
	panCard
});

export default myAccountReducer;
